import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b4ed5f9a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=b4ed5f9a&prod&lang=less&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=b4ed5f9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed5f9a",
  null
  
)

export default component.exports